import React from "react";
import { Box } from "@mui/material";

export const QqQuizControlContainerComponent: React.FunctionComponent = ({
  children,
}) => {
  return (
    <Box
      sx={{
        marginTop: "24px",
      }}
    >
      {children}
    </Box>
  );
};
